import apiClient from './apiClient';
import { AuthUtils } from '../utils/AuthUtils';

const CustomerService = {
  async getCustomers(page = 1, perPage = 20, searchQuery = '') {
    try {
      console.group('🔍 CustomerService: getCustomers');
      console.log('📄 Parameters:', { page, perPage, searchQuery });
      
      const response = await apiClient.get('/customers', {
        params: {
          page,
          per_page: perPage,
          search: searchQuery
        }
      });
      
      console.log('✅ Response Status:', response.status);
      console.log('📦 Response Data:', response.data);
      console.groupEnd();
      
      return response.data;
    } catch (error) {
      console.error('❌ CustomerService: getCustomers Error', error);
      
      // タイムアウトまたはネットワークエラーの場合はモックデータを返す
      if (error.code === 'ECONNABORTED' || error.code === 'ERR_NETWORK' || process.env.NODE_ENV === 'development') {
        console.log('⚠️ エラー発生のため、モックデータを返します');
        return { 
          customers: [
            { id: 'mock-1', name: '山田太郎', email: 'yamada@example.com', phone: '03-1234-5678' },
            { id: 'mock-2', name: '佐藤花子', email: 'sato@example.com', phone: '03-8765-4321' },
            { id: 'mock-3', name: '田中一郎', email: 'tanaka@example.com', phone: '03-2468-1357' },
            { id: 'mock-4', name: '鈴木美咲', email: 'suzuki@example.com', phone: '03-9876-5432' }
          ] 
        };
      }
      
      throw error;
    }
  },

  async createCustomer(customerData) {
    try {
      const response = await apiClient.post('/customers', customerData);
      return response.data;
    } catch (error) {
      console.error('顧客の作成に失敗しました:', error);
      throw error;
    }
  },

  async updateCustomer(customerId, customerData) {
    try {
      const response = await apiClient.put(`/customers/${customerId}`, customerData);
      return response.data;
    } catch (error) {
      console.error('顧客の更新に失敗しました:', error);
      throw error;
    }
  },

  async deleteCustomer(customerId) {
    try {
      await apiClient.delete(`/customers/${customerId}`);
    } catch (error) {
      console.error('顧客の削除に失敗しました:', error);
      throw error;
    }
  },

  // 顧客（userId）のオーダー履歴を取得。completedOnly=true で完了のみ。
  async getCustomerOrders(userId: number, completedOnly = false) {
    const response = await apiClient.get(`/customers/${userId}/orders`, {
      params: completedOnly ? { completed_only: true } : {},
    });
    return response.data; // { customer_id, user_id, customer_name, orders, summary }
  }
};

export const getCustomers = CustomerService.getCustomers;
export const getCustomerOrders = CustomerService.getCustomerOrders;
export default CustomerService;
